module.exports = __webpack_public_path__ + "static/media/warning-black.1fec10de.svg";